import { Head, router } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { foundingMemberCreatorResumptionPath, sessionPath } from "@travily/routes";
import type { FoundingMemberStatus } from "@travily/types/models/Enums";
import type WaitlistsShow from "@travily/types/pages/WaitlistsShow";
import { useShare } from "@ui/hooks/use-share";
import { usePostHog } from "posthog-js/react";
import { AuthFrame, aboutNavLink } from "@/layouts/auth-frame";
import { WaitlistView } from "./show.view";

function getMetaTitle(status: FoundingMemberStatus): string {
  if (status === "completed") {
    return t("web.waitlists.show.meta_title.completed");
  }
  return t("web.waitlists.show.meta_title.default");
}

const WaitlistPage = ({ founding_member }: WaitlistsShow) => {
  const posthog = usePostHog();
  const { share } = useShare();

  const handleLogout = () => {
    router.delete(sessionPath());
  };

  const handleContinueFoundingMember = () => {
    router.post(foundingMemberCreatorResumptionPath(), {});
  };

  // The column is a string to TypeScript, but the enum is the only thing the row can hold.
  const foundingStatus = founding_member.status as FoundingMemberStatus;
  const metaTitle = getMetaTitle(foundingStatus);

  const trackingProperties = {
    founding_member_status: foundingStatus,
    founding_member_type: founding_member.member_type,
  };

  const handleShare = () => {
    posthog.capture("waitlist_share_initiated", trackingProperties);

    share({
      title: t("web.waitlists.show.share_data.title"),
      text: t("web.waitlists.show.share_data.text"),
      url: "https://livetravily.com",
    });
  };

  return (
    <>
      <Head title={metaTitle}>
        <meta name="description" content={t("web.waitlists.show.meta_description")} />
      </Head>
      <AuthFrame
        navLinks={[aboutNavLink(), { id: "logout", label: t("web.waitlists.show.log_out"), onPress: handleLogout }]}
      >
        <WaitlistView
          foundingMemberType={founding_member.member_type}
          foundingMemberStatus={foundingStatus}
          onContinueFoundingMember={handleContinueFoundingMember}
          onShare={handleShare}
        />
      </AuthFrame>
    </>
  );
};

export default WaitlistPage;
